export default "__VITE_PUBLIC_ASSET__282a2bbe__"